var _rect, _g, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcPlatformOps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 200",
    width: 350,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 200,
    rx: 24,
    fill: "#2c2c6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4db5ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 40 L170 60 V100 C170 135 140 155 110 165 C80 155 50 135 50 100 V60 Z",
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 102 L104 121 L138 84"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 85,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Auth &amp;")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 110,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Platform")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 135,
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Reliability")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 160,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "accounts \xB7 incidents \xB7 analytics")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcPlatformOps);
export default __webpack_public_path__ + "static/media/KcPlatformOps.f4a25cf933502269452cb069a9a5587f.svg";
export { ForwardRef as ReactComponent };